webpackJsonp([178655142537844],{

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _BackNav = __webpack_require__(15);
	
	var _BackNav2 = _interopRequireDefault(_BackNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WritingPage = function WritingPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'half-page relative' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      '\uD83D\uDCDD Writing'
	    ),
	    _react2.default.createElement(_BackNav2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: 'indent' },
	      _react2.default.createElement(
	        'p',
	        null,
	        ' Follow me on ',
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', href: 'https://www.medium.com/@willdjthrill' },
	          'Medium'
	        ),
	        ' for instant udpates.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        ' Popular & recent articles:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'indent' },
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://medium.com/@willdjthrill/designing-delightful-business-software-51612a9f2f' },
	            'Designing Delightful Business Software'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://medium.com/@willdjthrill/the-design-process-a-pyramid-c77135c177d4' },
	            'The Design Process: A Pyramid'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://medium.com/@willdjthrill/waiting-for-a-sign-to-start-building-your-design-teams-component-library-c43f4352c764?source=user_profile---------4----------------' },
	            'Building a component library in Figma'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://medium.com/@willdjthrill/how-to-create-ideas-b1d8984f603d' },
	            'How to Create Ideas'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', href: 'https://medium.com/@willdjthrill/on-zen-and-design-bea3ecf4f9c1?source=user_profile---------13----------------' },
	            'On Zen and Design'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' },
	        'Go back to homepage'
	      )
	    )
	  );
	};
	
	exports.default = WritingPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-writing-js-d226367558a77d93e76d.js